import { render, staticRenderFns } from "./paymentNotification.vue?vue&type=template&id=6f4b7274"
import script from "./paymentNotification.vue?vue&type=script&lang=js"
export * from "./paymentNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports